import { ConfigEntryType } from 'config/config';
import * as Yup from 'yup';

export const getPredefinedFieldValidation = ({ field }: { field: ConfigEntryType }) => {
  switch (field.entryCode) {
    case 'title': {
      return field?.referenceObject?.isRequired || field?.referenceObject?.isRequired === undefined
        ? Yup.string().required('Title is required')
        : Yup.string();
    }

    case 'description': {
      return field.referenceObject?.isRequired
        ? Yup.string().required('Required field')
        : Yup.string();
    }

    default: {
      return null;
    }
  }
};
